import * as api from '../api';
import {
    HEALTHCARE_VENDOR_STATS_REQUEST,
    HEALTHCARE_VENDOR_STATS_SUCCESS,
    HEALTHCARE_VENDOR_STATS_FAIL,
} from "../constants/webOrderConstants";


// `opts.outletId`: the branch the navbar shows (undefined = every location this login may see).
export const fetchHealthcareVendorOrderStats = (vendorId, opts = {}) => async (dispatch) => {
    try {
        dispatch({ type: HEALTHCARE_VENDOR_STATS_REQUEST });

        const { data } = await api.fetchHealthcareVendorStatsApi(vendorId, opts);

        dispatch({
            type: HEALTHCARE_VENDOR_STATS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: HEALTHCARE_VENDOR_STATS_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

